import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { docScriptApiService } from 'src/services';
import { objLen } from 'src/utils/general';

export const useScriptsStore = defineStore('scripts', {
  state: () => ({
    script_list: {} as dynamicObj,
    selected_record: {} as dynamicObj,
    doc_type_key: '',
    sub_doc_type_key: '',
    processing: false,
  }),
  getters: {},
  actions: {
    async getScripts(doc_type: string, sub_doc_type_key: string) {
      try {
        const data = {} as dynamicObj;
        if (sub_doc_type_key) {
          data.sub_doc_type = sub_doc_type_key;
        }
        const response = await docScriptApiService.getByDocTypeSubDocType(
          doc_type,
          data,
        );

        if (!Array.isArray(response) || objLen(response[0]) == 0) {
          return;
        }

        // this.script_list = response;
        if (response) {
          return response as dynamicObj;
        }
      } catch (err) {
        throw err;
      }
    },

    getListRoute(params: dynamicObj) {
      let navigateTo = '';
      try {
        navigateTo = '/manage_scripts/' + params.doc_type_key;

        if (params.sub_doc_type_key) {
          navigateTo += '?sub_doc_type=' + params.sub_doc_type_key;
        }
      } catch (err) {
        logError(err);
      }
      return navigateTo;
    },
  },
});
